import { all } from 'redux-saga/effects';

import proposta from './proposta/sagas';
import posPagamentoContrato from './posPagamentoContrato/sagas';

export default function* rootSaga() {
  return yield all([proposta, posPagamentoContrato]);
}
